/**
 * Parses a button function string into a function key and parameter
 * @param {string|null} buttonFunc - Button function string in format "funcKey:param"
 * @returns {[string|undefined, string|undefined]} Tuple of [funcKey, param]
 * @example
 * parseButtonFunc("openModal:STAX_KYC") // Returns ["openModal", "STAX_KYC"]
 * parseButtonFunc("openTextComposer") // Returns ["openTextComposer", undefined]
 * parseButtonFunc(null) // Returns [undefined, undefined]
 */

function parseButtonFunc(buttonFunc) {
  if (!buttonFunc || buttonFunc === "") return [undefined, undefined];

  const firstColon = buttonFunc.indexOf(":");
  return firstColon === -1
    ? [buttonFunc, undefined]
    : [buttonFunc.slice(0, firstColon), buttonFunc.slice(firstColon + 1)];
}

export { parseButtonFunc };
